<template>
    <div id="zyno-signup">
        <router-view />
    </div>
</template>

<script lang="ts" setup>
import './signup.styles.css';
// The dark ramp is imported here rather than from `signup.styles.css` so it reaches the embedded app
// only: the SPA imports those styles too (the MSP order builder) and ships one scheme.
import './signup.theme.css';
import { useEmbedHeightReporter } from './core/embed';
import { useEmbedTheme } from './core/theme';

// Root of the standalone signup app. The wizard itself is `signup-wizard.vue`, which the SPA also
// mounts directly — this shell is only the embedded surface, which is why height reporting and
// theme-following live here and not there.
//
// No OverlayContainer, unlike the CX root: that comes from @zyno-io/vue-foundation, and signup
// deliberately doesn't call setupVf() (see signup.main.ts). Add both together if a step ever needs
// modals or alerts.
useEmbedHeightReporter();
useEmbedTheme();
</script>
